import { useContext, useEffect, useMemo, useState } from "react";
import Skeleton from "react-loading-skeleton";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import "../../../styles/dashboard/transaction/transactionIndex.css";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import {
  RazorBadgeTwo,
  RazorDateTime,
  RazorNumberFormat,
  RazorTable,
  RazorTableRow,
  RazorTextTrim,
  RazorTwinValue,
} from "../../../components/razor-reuse";
import FilterReusableComp from "../../../components/FilterReusableComp";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import {
  getZojapayTransaction,
  getZojapayTransactionCsv,
} from "../../../redux/transaction";
import DateRangeComponent from "../../../components/fragment/date-range/DateRangeComponent";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { systemRoles } from "../../../utils/roles";
import ActionContext from "../../../context/ActionContext";

const ZojapayTransaction = () => {
  const actionCtx = useContext(ActionContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filterOneVal, setFilterOneVal] = useState<any>("");

  const { user } = useSelector((state: RootState) => state.auth);
  const { loading_zojapay, zojapy_transaction } = useSelector(
    (state: RootState) => state.transaction,
  );

  const headerList = [
    "Beneficiary Name",
    "Narration",
    "Stamp Duty",
    "Service Charge",
    "Amount",
    "Type",
    "Date",
    "Status",
  ];

  const selectListOne = [
    { label: "Debit", value: "debit" },
    { label: "Credit", value: "credit" },
    { label: "All Type", value: "" },
  ];

  const [dateRange, setDateRange] = useState("");
  const [search, setSearch] = useState("");
  const [currentPageVal, setCurrentPage] = useState(1);

  // useEffect to check if user has permission to view transactions
  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[11]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, [user?.permissions]);

  const obj = {
    page: currentPageVal,
    per_page: actionCtx?.perPage?.label,
    search: search,
    "filter[type]": filterOneVal?.value,
    "filter[date]": dateRange,
  };
  useEffect(() => {
    if (user?.permissions?.includes(systemRoles[11])) {
      dispatch(getZojapayTransaction(obj) as any);
    }
  }, [
    currentPageVal,
    dateRange,
    filterOneVal,
    actionCtx?.perPage,
    dispatch,
    user?.permissions,
    search,
  ]);

  return (
    <>
      <DashboardLayoutMain
        loading={
          loading_zojapay &&
          !(zojapy_transaction?.transactions?.data?.length > 0)
        }
        title="Zojapay Transactions"
      >
        <div className="transaction-index-wrap-box-smartsend">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-[24px] mb-[20px]">
            <div className="bg-white rounded-[12px] px-[20px] py-[18px]">
              <h3 className="text-[14px] font-medium text-gray-600 mb-[12px] truncate">
                Total Inflow
              </h3>
              {loading_zojapay ? (
                <Skeleton className="number" width={100} height={50} />
              ) : (
                <p className="text-[40px] font-bold text-black">
                  {RazorNumberFormat(zojapy_transaction?.totals?.total_inflow, {
                    hideDecimal: true,
                    numberAbbreviate:
                      String(zojapy_transaction?.totals?.total_inflow)?.length >
                      5,
                  })}
                </p>
              )}
            </div>

            <div className="bg-white rounded-[12px] px-[20px] py-[18px]">
              <h3 className="text-[14px] font-medium text-gray-600 mb-[12px] truncate">
                Total Outflow
              </h3>
              {loading_zojapay ? (
                <Skeleton className="number" width={100} height={50} />
              ) : (
                <p className="text-[40px] font-bold text-black">
                  {RazorNumberFormat(
                    zojapy_transaction?.totals?.total_outflow,
                    {
                      hideDecimal: true,
                      numberAbbreviate:
                        String(zojapy_transaction?.totals?.total_outflow)
                          ?.length > 5,
                    },
                  )}
                </p>
              )}
            </div>
          </div>

          <FilterReusableComp
            defaultSelectOne="Transaction Type"
            selectOneList={selectListOne}
            selectOneValue={filterOneVal}
            onSelectOne={(param) => {
              setFilterOneVal(param);
              setCurrentPage(1);
            }}
            hideSearch
            hideExport={
              !user?.permissions?.includes("export_zojapay_transaction")
            }
            onExport={() => {
              dispatch(getZojapayTransactionCsv(obj) as any);
            }}
            moreComponents={
              <>
                <DateRangeComponent
                  onSet={(param) => {
                    setDateRange(param);
                    setCurrentPage(1);
                  }}
                  value={dateRange}
                  onCancel={() => {
                    setDateRange("");
                    setCurrentPage(1);
                  }}
                />
              </>
            }
          />
          {/* filter section end */}
          {/* table start */}
          <div className="table-section-box">
            <RazorTable headerList={headerList}>
              {zojapy_transaction?.transactions?.data?.map(
                (chi: any, idx: any) => {
                  return (
                    <RazorTableRow
                      key={idx}
                      one={
                        <RazorTwinValue
                          one={RazorTextTrim(
                            chi?.beneficiary?.accountNumber || "----",
                            45,
                          )}
                          two={chi?.beneficiary?.accountName || ""}
                        />
                      }
                      two={RazorTextTrim(chi?.narration || "----", 20)}
                      three={RazorNumberFormat(chi?.stampDuty, {
                        hideSymbol: false,
                        symbol: chi?.source_currency?.code,
                      })}
                      four={RazorNumberFormat(chi?.charge, {
                        hideSymbol: false,
                        symbol: chi?.source_currency?.code,
                      })}
                      five={RazorNumberFormat(chi?.amount, {
                        hideSymbol: false,
                        symbol: chi?.source_currency?.code,
                      })}
                      six={chi?.transactionType || "---"}
                      loading={loading_zojapay}
                      seven={<RazorDateTime date={chi?.createdAt} />}
                      eight={
                        <RazorBadgeTwo
                          className={
                            chi?.transactionStatus === "failed"
                              ? "failed"
                              : chi?.transactionStatus === "successful"
                                ? "success"
                                : chi?.transactionStatus === "completed"
                                  ? "success"
                                  : chi?.transactionStatus === "pending"
                                    ? "pending"
                                    : chi?.transactionStatus === "processing"
                                      ? "pending"
                                      : chi?.transactionStatus === "submitted"
                                        ? "pending"
                                        : ""
                          }
                          text={chi?.transactionStatus}
                        />
                      }
                    />
                  );
                },
              )}
            </RazorTable>
          </div>
          {/* table end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={
              zojapy_transaction?.transactions?.meta?.current_page || 1
            }
            perPage={zojapy_transaction?.transactions?.meta?.per_page}
            totalPage={zojapy_transaction?.transactions?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading_zojapay}
            showPerPage
          />
          {/* pagination end */}
        </div>
      </DashboardLayoutMain>
    </>
  );
};

export default ZojapayTransaction;
